<template>
  <button
    class="root flex items-center justify-center text-sm sm:text-base fw-strong c-gray-700 hover:c-gray-900"
    :class="{ expanded }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <SloIcon name="Plus" />
    <span class="ml-sm">{{ expanded ? 'Hide' : 'View' | t }}
      <slot />
    </span>
  </button>
</template>

<script>
import t from '../../main/i18n';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: {
    expanded: {type: Boolean}
  },
  filters: {
    t
  }
};
</script>

<style lang="scss" scoped>
.root {
  background: none;
  padding: 0;
  margin: 0;
}

.root .slo-icon {
  transition: transform 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.expanded .slo-icon {
  transform: rotate(45deg);
}
</style>
